import React, { useCallback, useEffect, useMemo, useState } from "react";

import {
  Box,
  Button,
  Card,
  Flex,
  Grid,
  SearchBox,
  PageHeading,
  Loader,
  NoData,
  Toastify,
} from "atoms";
import Table from "molecules/Table";
import MemoDeleteIcon from "assets/icons/DeleteIcon";
import MemoEdit from "assets/icons/Edit";
import MemoBlock from "assets/icons/Block";
import MemoAdd from "assets/icons/Add";
import { usePropsoch } from "contexts/Propsoch";
import { AddNewLocationModal } from "molecules/Modals/AddNewLocationModal";
import { ConfirmationModal } from "molecules/Modals";

const columns = [
  {
    title: "Name",
    field: "name",
    sortKey: "name",
    render: (row) => <>{row.role}</>,
  },
  // {
  //   title: "Email",
  //   field: "email",
  //   sortKey: "email",
  //   render: (row) => <>{row.email}</>,
  // },
  // {
  //   title: "Status",
  //   field: "status",
  //   sortKey: "status",
  //   render: (row) => (
  //     <Box
  //       color="white"
  //       p="0.4rem 1.6rem"
  //       width="fit-content"
  //       borderRadius="1rem"
  //       fontSize="1.2rem"
  //       fontFamily="NeometricBold"
  //       textTransform="capitalize"
  //       bg={statusColor(row.status.toLowerCase())}
  //     >
  //       {row.status}
  //     </Box>
  //   ),
  // },

  {
    title: "Actions",
    // rightAligned: true,
    render: (row) => (
      <Grid
        gridAutoFlow="column"
        gridGap="1.8rem"
        justifyContent="start"
        alignItems="center"
        color="neutral.600"
      >
        <Box color="neutral.900" cursor="pointer">
          <MemoEdit height="1.8rem" width="1.8rem" />
        </Box>
        <Box color="neutral.900" cursor="pointer">
          <MemoBlock height="2rem" width="2rem" />
        </Box>
        <Box color="accents.100" cursor="pointer">
          <MemoDeleteIcon height="2rem" width="2rem" />
        </Box>
      </Grid>
    ),
  },
];

const Location = () => {
  const [search, setSearch] = useState("");
  const [isModalVisible, setModalVisible] = useState(false);

  // roles crud
  const {
    state: { locations, userRole },
    actions: { getLocation, createLocation, updateLocation, deleteLocation },
  } = usePropsoch();

  const [loading, setLoading] = useState(false);

  const fetchLocation = useCallback(() => {
    setLoading(true);
    getLocation()
      .then(() => {})
      .catch(console.error)
      .finally(() => {
        setLoading(false);
      });
  }, [getLocation]);

  useEffect(() => {
    fetchLocation();
  }, [fetchLocation]);

  // roles crud end
  const [deleteModal, setDeleteModal] = useState(false);

  const isAuthorisedToAdd = useMemo(() => {
    return userRole?.isSuperadmin || userRole?.isAdmin;
  }, [userRole?.isSuperadmin, userRole?.isAdmin]);

  const isAuthorisedToEdit = useMemo(() => {
    return userRole?.isSuperadmin || userRole?.isAdmin;
  }, [userRole?.isSuperadmin, userRole?.isAdmin]);

  const isAuthorisedToDelete = useMemo(() => {
    return userRole?.isSuperadmin || userRole?.isAdmin;
  }, [userRole?.isSuperadmin, userRole?.isAdmin]);

  return (
    <Box>
      <Flex justifyContent="space-between" pb="2.4rem">
        <PageHeading text="Location" mt="1.8rem" />
        <Button
          variant="primary"
          width="fit-content"
          px="2rem"
          height="4.8rem"
          onClick={() => setModalVisible({ visible: true })}
          disabled={!isAuthorisedToAdd}
        >
          <Flex justifyContent="center" alignItems="center" gridGap="2rem">
            <MemoAdd />
            Add New Location
          </Flex>
        </Button>
      </Flex>
      <Card>
        <SearchBox
          value={search}
          onChange={(e) => setSearch(e.target.value)}
          onClose={() => setSearch("")}
          placeholder="Search Location"
          style={{ width: "30rem" }}
          removeValidationIcon={!search}
        />
        <Box mt="2.4rem" {...(loading && { minHeight: "4rem" })}>
          <Loader loading={loading}>
            <Table
              tableHeader={columns.map(({ title, rightAligned }) => ({
                name: title,
                rightAligned,
                containerProps: {
                  fontSize: "1.4rem",
                  fontWeight: "600",
                },
              }))}
              borderColor="neutral.500"
            >
              <Box as="tbody" bg="white">
                {locations
                  ?.filter((location) =>
                    location?.name
                      ?.toLowerCase()
                      ?.includes(search?.toLowerCase())
                  )
                  ?.map((location, index) => (
                    <tr key={index}>
                      <td>{location?.name}</td>
                      <td>
                        <Grid
                          gridAutoFlow="column"
                          gridGap="1.8rem"
                          justifyContent="start"
                          alignItems="center"
                          color="neutral.600"
                        >
                          <Box
                            color={
                              isAuthorisedToEdit ? "neutral.900" : "neutral.300"
                            }
                            cursor={
                              isAuthorisedToEdit ? "pointer" : "not-allowed"
                            }
                            onClick={
                              isAuthorisedToEdit
                                ? () =>
                                    setModalVisible({ visible: true, location })
                                : undefined
                            }
                          >
                            <MemoEdit height="1.8rem" width="1.8rem" />
                          </Box>
                          {/* <Box color="neutral.900" cursor="pointer">
                        <MemoBlock height="2rem" width="2rem" />
                      </Box> */}
                          <Box
                            color={
                              isAuthorisedToDelete
                                ? "accents.100"
                                : "neutral.300"
                            }
                            cursor={
                              isAuthorisedToDelete ? "pointer" : "not-allowed"
                            }
                            onClick={
                              isAuthorisedToDelete
                                ? () => {
                                    setDeleteModal({
                                      onClose: () => setDeleteModal(false),
                                      icon: {
                                        Icon: MemoDeleteIcon,
                                        ICprops: { color: "accents.100" },
                                      },
                                      textOne: "Are you sure you want to",
                                      textTwo: "delete",
                                      textThree: `the location`,
                                      textFour: location?.name,
                                      onConfirm: () => {
                                        setLoading(true);
                                        deleteLocation(location?.id)
                                          ?.then(() => {
                                            Toastify(
                                              "success",
                                              `${location?.name} deleted successfully`
                                            );
                                          })
                                          ?.catch((e) => {
                                            console.error(e);
                                            Toastify(
                                              "error",
                                              `Failed to delete ${location?.name}`
                                            );
                                          })
                                          .finally(() => {
                                            fetchLocation();
                                          });
                                        setDeleteModal(false);
                                      },
                                    });
                                  }
                                : undefined
                            }
                          >
                            <MemoDeleteIcon height="2rem" width="2rem" />
                          </Box>
                        </Grid>
                      </td>
                    </tr>
                  ))}
              </Box>
            </Table>
            {locations?.filter((location) =>
              location?.name?.toLowerCase()?.includes(search?.toLowerCase())
            )?.length === 0 && <NoData />}
          </Loader>
          {/* <RcePagination
        data={data}
        current={current}
        setCurrent={setCurrent}
        showTotal={(total, range) => `${range[0]} - ${range[1]} of ${total} items`}
      /> */}
        </Box>
      </Card>
      {isModalVisible?.visible && (
        <AddNewLocationModal
          isOpen={isModalVisible?.visible}
          onClose={() => setModalVisible(false)}
          loading={isModalVisible?.loading}
          error={isModalVisible?.error}
          resetError={() =>
            setModalVisible((prev) => ({
              ...prev,
              error: "",
            }))
          }
          preLocation={isModalVisible?.location}
          onSubmit={({ location, isActive }) => {
            setModalVisible((prev) => ({ ...prev, loading: true }));
            if (isModalVisible?.location) {
              updateLocation(isModalVisible?.location?.id, location, !!isActive)
                ?.then(() => {
                  setModalVisible(false);
                  Toastify("success", `${location} updated successfully`);
                })
                ?.catch((e) => {
                  setModalVisible((prev) => ({
                    ...prev,
                    loading: false,
                    error: e?.message,
                  }));
                  Toastify("error", `Failed to update ${location}`);
                })
                .finally(() => {
                  fetchLocation();
                });
            } else {
              createLocation(location, !!isActive)
                ?.then(() => {
                  setModalVisible(false);
                  Toastify("success", `${location} created successfully`);
                })
                ?.catch((e) => {
                  setModalVisible((prev) => ({
                    ...prev,
                    loading: false,
                    error: e?.message,
                  }));
                  Toastify("error", `Failed to create ${location}`);
                })
                .finally(() => {
                  fetchLocation();
                });
            }
          }}
        />
      )}
      {deleteModal && <ConfirmationModal {...deleteModal} />}
    </Box>
  );
};

export default Location;
